import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

import { Api } from "../api";
import { User } from "../../models/user.model";

@Injectable()
export class UserProvider extends Api {

  constructor(public http: HttpClient) {
    super(http);
  }

  getByID(id: number): Observable<User> {
    return this.http
      .get<User>(`${this.url}/users/${id}`)
      .map(response => {
        return new User(response);
      })
      .catch(this.handleError)
  }

  register(data: any): Observable<Object> {
    let headersConfig = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    return this.http
      .post(`${this.url}/users/register`, data, {
        headers: headersConfig
      })
      .catch(this.handleError);
  }

}



// WEBPACK FOOTER //
// ./src/providers/user/user.ts